<template>
  <footer class="app-footer">
    <span>&copy; 2018 <a href="http://www.unilab.eu/">Unilab</a></span>
    <!-- <span class="ml-auto">Powered by <a href="http://coreui.io">CoreUI</a></span> -->
  </footer>
</template>
<script>
export default {
  name: "Footer"
};
</script>
